
/**
 * Popup message to the user
 * @param type = string (good, bad, default, etc)
 * @param message = string (words to show)
 * @param extraClasses = string (optional)
 * @param sticky = boolean (optional, don't timeout and hide)
 **/
export function Create(type, message, extraClasses, sticky){
	
	if (typeof(extraClasses) === 'undefined') var extraClasses = '';
	if (typeof(sticky) === 'undefined') var sticky = false;
	
	var popup = $('<div class="notifications__item notifications__item--'+type+''+extraClasses+'">'+message+'<div class="notifications__item__close"><i class="fa fa-close"></i></div></div>');
	$(document).find('#notifications').append(popup);	

	popup.fadeIn('fast');
	
	if (!sticky){
		popup.delay(3000).fadeOut(
			'slow', 
			function(){ 
				popup.remove()
			}
		);
	}
}


/**
 * Close the popup
 * This is bound outside of the class because some notifications
 * may be created by the core render (ie Sessions, Page::setMessage()) so isn't
 * created by JS
 **/
$(document).on('click', '.notifications__item__close', function(e){
	$(this).closest('.notifications__item').remove();
});


